import { Button, FlexGrid, Header, Image, ResponsiveImageSet, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { noop } from '../../../lib/utils';
import formatDiscount from '../../../lib/utils/formatDiscount';
import styles from './GasbackPayPromo.module.css';

const cx = classnames.bind(styles);

export default function GasbackPayPromo({ onButtonClick }) {
  return (
    <FlexGrid className={cx('grid')}>
      <FlexGrid.Column tablet={6} tabletOffset={1}>
        <Image
          className={cx('card')}
          src="https://static.gasbuddy.com/web/pay/svg/card-tilted-shadow-v2.svg"
          alt="Pay with GasBuddy example card"
          width={80}
        />
        <Header as="h2" className={cx('header')} snug>
          One card, unlimited GasBack savings.
        </Header>
        <Text as="p" className={cx('text')}>
          You&apos;ll use your Pay with GasBuddy card to purchase gas at the pump.
          In addition to redeeming your GasBack, the card saves you up to {formatDiscount(25)} per gallon. It&apos;s
          completely free, requires no paperwork or credit check, and is the one gas card accepted at
          stations nationwide.
        </Text>
        <Button as="a" href="/pay" className={cx('button')} secondary wide onClick={onButtonClick}>
          <span>Learn More</span>
          <Text screenReader> About Pay With GasBuddy</Text>
        </Button>
      </FlexGrid.Column>
      <FlexGrid.Column tablet={5}>
        <div className={cx('image')}>
          <ResponsiveImageSet
            src="https://static.gasbuddy.com/web/consumer/card-and-phone-in-hand.png"
            alt="Woman with GasBuddy Pay card in hand"
            fluid
          />
        </div>
      </FlexGrid.Column>
    </FlexGrid>
  );
}

GasbackPayPromo.propTypes = {
  onButtonClick: PropTypes.func,
};

GasbackPayPromo.defaultProps = {
  onButtonClick: noop,
};
